import {API_URLS} from '@px/const/urls';
import {http} from '@px/helper/http';
import {klineUtil} from '@px/helper/kline';

// 必须是所有周期的倍数，否则时间边界不能确保为整点
const LIMIT = 1200;

export const klineApi = {
  async getHistoryData(query, tradePair) {
    const {symbol} = query;
    const resolution = query.resolution * 60; // 分钟转为秒
    const from = roundDown(query.from, resolution);
    const to = roundUp(query.to, resolution);
    const ranges = splitRange(from, to, resolution);
    const res = await loopLoadKlineData(tradePair.type === 'PerpetualV2' ? API_URLS.KLINE_V2 : API_URLS.KLINE, ranges.reverse(), {symbol, resolution});

    return {
      data: {
        symbol,
        resolution: query.resolution, // 与传入参数保持一致
        items: res ? res.filter(([time]) => time >= query.from && time < query.to).map((o) => klineUtil.convertToBar(o, tradePair)) : [],
      },
    };
  },
  getTrend(query) {
    return http.get(API_URLS.TREND, {query});
  },
};

function splitRange(from, to, resolution): {from: number; to: number}[] {
  const gap = resolution * LIMIT;
  if (to - from < gap) {
    return [{from, to}];
  }
  return [{to, from: to - gap}, ...splitRange(from, to - gap, resolution)];
}

function roundDown(t, resolution) {
  return round(t, resolution, Math.floor);
}

function roundUp(t, resolution) {
  return round(t, resolution, Math.ceil);
}

function round(t, resolution, fun) {
  const now = Date.now() / 1000;
  // 周期小于1小时，按小时 round
  if (resolution < 3600 && now - t > 3600) {
    return fun(t / 3600) * 3600;
  }
  // 周期小于1天，按天 round
  if (resolution < 86400 && now - t > 86400) {
    return fun(t / 86400) * 86400;
  }
  // 周期小于30天，按30天 round
  if (resolution < 2592000 && now - t > 2592000) {
    return fun(t / 2592000) * 2592000;
  }
  return t;
}

async function loopLoadKlineData(url, ranges: {from: number; to: number}[], query, res = []) {
  if (ranges.length === 0) {
    return res;
  }
  const range = ranges.shift();
  const {error, data} = await http.get(url, {query: {...query, from: range.from, to: range.to}});

  if (error) {
    return false;
  }
  const res2 = res.concat(data.rows);
  if (ranges.length > 0) {
    return await loopLoadKlineData(url, ranges, query, res2);
  }
  return res2;
}
